import {
    MDXEditor,
    linkPlugin,
    listsPlugin,
    quotePlugin,
    tablePlugin,
    headingsPlugin,
    linkDialogPlugin,
    diffSourcePlugin,
    frontmatterPlugin,
    markdownShortcutPlugin,
} from "@mdxeditor/editor";
import "@mdxeditor/editor/style.css";
import PropTypes from "prop-types";
import { cn, generateUUID } from "../../../shared/utils";

export default function MarkdownPreview({ text }) {
    // `ecotic-mdx-readonly` merge pe RADACINA editorului, nu pe contentEditable:
    // acolo isi declara MDXEditor propriul `--font-body`, iar o variabila se ia de pe
    // elementul care o declara sau de pe un stramos. Regula e in main.css.
    return (
        <MDXEditor
            disabled={true}
            readOnly={true}
            spellCheck={false}
            markdown={text || ""}
            onChange={() => true}
            key={generateUUID()}
            plugins={[
                linkPlugin(),
                listsPlugin(),
                quotePlugin(),
                tablePlugin(),
                headingsPlugin(),
                linkDialogPlugin(),
                markdownShortcutPlugin(),
                diffSourcePlugin({ diffMarkdown: "An older version", viewMode: "rich-text" }),
                frontmatterPlugin(),
            ]}
            className="ecotic-mdx-readonly"
            contentEditableClassName={cn(!text ? "" : "", "p-0 markdown p-0 rounded-md")}
        />
    );
}
MarkdownPreview.propTypes = {
    text: PropTypes.string,
};
